import React from 'react';
import { NavLink } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import classNames from 'classnames';
import { ReactComponent as CircleLogo } from '@/assets/images/instil-circle-logo.svg';
import { ReactComponent as Logo } from '@/assets/images/instil-logo.svg';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import translate from '@/lib/intl/translate';
import { LayoutContext } from './LayoutProvider';
import useCompanyNavListItem from './useCompanyNavListItem';

function NavigationHeader() {
  const { isExpanded, showHover } = React.useContext(LayoutContext);

  const { avatar, orgNameInitials, orgName } = useCompanyNavListItem();

  return (
    <>
      <ListItem
        divider
        component={NavLink}
        to={AuthRoutes.LANDING}
        className="flex items-center justify-start p-4"
      >
        <CircleLogo
          aria-label={translate('ICON_INSTIL_LOGO_ICON')}
          className="h-8 min-w-[32px]"
        />
        <div
          className={classNames(
            'ml-3 min-w-[140px] transition-opacity duration-100',
            {
              'opacity-100': isExpanded || showHover,
              'opacity-0': !isExpanded && !showHover,
            },
          )}
        >
          <Logo
            aria-label={translate('ICON_INSTIL_LOGO')}
            className="[&_path]:fill-text-primary"
          />
        </div>
      </ListItem>
      <ListItem
        className="gap-2 py-5"
        component="div"
        data-testid="navigation-list-header"
      >
        <ListItemIcon className="min-w-[32px]">
          <Avatar
            className="h-8 w-8 rounded-lg text-base text-primary-main"
            data-testid="navigation-org-id-icon"
            alt={orgName}
            src={avatar}
            variant="square"
          >
            {orgNameInitials}
          </Avatar>
        </ListItemIcon>
        <ListItemText
          className={classNames(
            'my-0 w-[140px] transition-opacity duration-100',
            {
              'opacity-100': isExpanded || showHover,
              'opacity-0': !isExpanded && !showHover,
            },
          )}
          disableTypography
          primary={
            <div className="w-[140px] text-sm font-medium text-text-primary">
              {orgName}
            </div>
          }
        />
      </ListItem>
    </>
  );
}

export default NavigationHeader;
